
//import { CONSTANTS } from "../../../constants.js";

export default {
  props: {
    share: Array
  },
  data() {
    return {
      open: false,
    };
  }
  ,
  methods: {
    copyToClipboard(link) {
      navigator.clipboard.writeText(link);
      this.$toast.show("Copied link!", { position: "bottom-center" }).goAway(2000);
    },
  }
};
